
export const formatDateTime = (date) => {
  const d = new Date(date);

  const year = d.getUTCFullYear();
  const month = String(d.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const day = String(d.getUTCDate()).padStart(2, "0");
  const hours = String(d.getUTCHours()).padStart(2, "0");
  const minutes = String(d.getUTCMinutes()).padStart(2, "0");
  const seconds = String(d.getUTCSeconds()).padStart(2, "0");
  const milliseconds = String(d.getUTCMilliseconds()).padStart(3, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
};

export const getUserRole = (role) => {
  
  const userRole = localStorage.getItem('role');  
  //console.log(userRole);
  return userRole === role;

};

export const getBread = (id) => {
    
  let bread;
    if (id == '-res'){
      bread = 'Residents';        
    }else
    if (id == '-chart'){
     bread = 'Charting Notes';
    }else
    if (id == '-vit'){
      bread = 'Vitals Information';
     }else
     if (id == '-adl'){
      bread = 'ADL';
     }else
     if (id == '-ins'){
      bread = 'Insurances';
     }else
     if (id == '-prov'){
      bread = 'Providers';
     }else
     if (id == '-doc'){
      bread = 'Documents';
     }else
     if (id == '-cont'){
      bread = 'Contacts';
     }else
    {
      bread='';
    }      
    return bread;
 

};

export const formatTimeHHMMSSMMM = (time) => {
  // Split the original time into hours and minutes
  const [hours, minutes] = time.split(':');

  // Ensure hours and minutes are two digits
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');

  // Add seconds and milliseconds
  const seconds = '00';
  const milliseconds = '000';

  return `${formattedHours}:${formattedMinutes}:${seconds}:${milliseconds}`;
};

export const formatTimeHHMM = (time) => {

  return time.slice(0,5);

};

export const formatDate = (date) => {
  const options = { year: "numeric", month: "long", day: "numeric" };
  return new Date(date).toLocaleDateString(undefined, options);
};

export const formatDateTimeNormal = (isoString) => {
  const date = new Date(isoString);

  const optionsDate = { day: "2-digit", month: "2-digit", year: "numeric" };
  const optionsTime = { hour: "2-digit", minute: "2-digit", hour12: true };

  const formattedDate = date.toLocaleDateString(undefined, optionsDate);
  const formattedTime = date
    .toLocaleTimeString(undefined, optionsTime)
    .toUpperCase();

  return `${formattedDate.replace(/\//g, "-")} ${formattedTime}`;
};


export const documentTypes = [
    { value: '1', text: 'Admission Papers' },
    { value: '2', text: 'Health Information' },
    { value: '3', text: 'Lab Work' },
    { value: '4', text: 'Comprehensive Plan' },
    { value: '5', text: 'Covid 19' },
    { value: '6', text: 'Doctor Orders' },
    { value: '7', text: 'MAR' },
    { value: '8', text: 'New Orders' },
    { value: '9', text: 'Power of Attorney' },
    { value: '10', text: 'Progress Notes' },
    { value: '11', text: 'Service Care Plan' },
    { value: '12', text: 'Vaccination' }
  ];

  export const insuranceTypes = [
    { value: '1', text: 'Primary Insurance' },
    { value: '2', text: 'Secondary Insurance' },
    { value: '3', text: 'Medicare' },
    { value: '4', text: 'Prescription Coverage' },    
    { value: '5', text: 'Long Term Care Insurance' }, 
    { value: '6', text: 'MMA' },  
    { value: '7', text: 'Medicaid' }
  ];

  export const providerTypes = [
    { value: '1', text: 'Primary Physician'},
   
  ];


  export const contactTypes = [
    { value: '1', text: 'Primary and Responsible party' },
    { value: '2', text: 'Secondary Contact' },
    { value: '3', text: 'Guardian' },
    { value: '4', text: 'Other Contact' }    
  ];

  export const mobilitydeviceTypes = [
    { value: '1', text: 'None' },
    { value: '2', text: 'Cane' },
    { value: '3', text: 'Walker' },
    { value: '4', text: 'Other Contact' }    
  ];

  export const vitalTypes = [
    { value: '1', text: 'Weight', showUnit: false, unit: '', showSleep: false, showBowel: false},
    { value: '2', text: 'Pulse', showUnit: false, unit: '' , showSleep: false, showBowel: false},
    { value: '3', text: 'Blood Pressure', showUnit: false, unit: '' , showSleep: false, showBowel: false},
    { value: '4', text: 'Blood Sugar', showUnit: false, unit: '', showSleep: false, showBowel: false },    
    { value: '5', text: 'Temperature', showUnit: false, unit: '', showSleep: false, showBowel: false},
    { value: '6', text: 'O2 Saturation%', showUnit: false, unit: '', showSleep: false, showBowel: false },
    { value: '7', text: 'Pain', showUnit: false, unit: '' , showSleep: false, showBowel: false},
    { value: '8', text: 'Respirations', showUnit: false, unit: '', showSleep: false, showBowel: false },
    { value: '9', text: 'Bowel Movement', showUnit: false, unit: '', showSleep: false, showBowel: true },
    { value: '10', text: 'Food Eaten', showUnit: false, unit: '' , showSleep: false, showBowel: false},
    { value: '11', text: '% of Fluid Intake', showUnit: false, unit: '', showSleep: false, showBowel: false },
    { value: '12', text: 'Track Sleep', showUnit: false, unit: '' , showSleep: true, showBowel: false},
    { value: '13', text: 'Head Circumference', showUnit: true, unit: 'cm', showSleep: false, showBowel: false },
    { value: '14', text: 'Urine Output', showUnit: true, unit: 'ml/cc', showSleep: false, showBowel: false }
  ];

  export const sizeTypes = [
    {value: '1', text: 'Small'},
    {value: '2', text: 'Medium'},
    {value: '3', text: 'Large'}
  ];

  export const noteTypes = [
    {value: '1', text: 'Observation Notes'},
    {value: '2', text: 'Narrative'},
    {value: '3', text: 'Progress'},
    {value: '4', text: 'Other'}
  ];

  export const witnessTypes = [
    {value: '1', text: 'Witnessed'},
    {value: '2', text: 'Self Reported'},
    {value: '3', text: 'Third Party Reported'}
  ];

  export const consistencyTypes = [
    {value: '1', text: 'Hard'},
    {value: '2', text: 'Formed'},
    {value: '3', text: 'Mushy'},
    {value: '4', text: 'Liquid'}
  ];

  export const activityTypes = [
    {value: '1', text: 'BM in Toilet'},
    {value: '2', text: 'BM in Diaper'},
    {value: '3', text: 'BM in Soiled Self'},
    {value: '4', text: 'Inquired No BM'},
    {value: '5', text: 'Toilet Sit - No BM'},
    {value: '6', text: 'Void'}
  ];

  export const continenceTypes = [
    {value: '1', text: 'Continent'},
    {value: '2', text: 'Incontinent'}
  ];

  export const scheduleTypes = [
    {value: '1', text: 'Daily', showDaily:true, showDWeek:false},
    {value: '2', text: 'Days of Week', showDaily:false, showDWeek:true}
  ];


  export const adlTypes = [
    {value: '1', text: 'Routine', showRoutine:true},
    {value: '2', text: 'PRN', showRoutine:false}
  ];

  export const adlActivities = [
    {value: '1', text: 'Breakfast'},
    {value: '2', text: 'Lunch'},
    {value: '3', text: 'Dinner'},
    {value: '4', text: 'Shower'},
    {value: '5', text: 'Sponge Bath'},
    {value: '6', text: 'Mouth Care'},
    {value: '7', text: 'Bedtime Snack'},
    {value: '8', text: 'Blood Sugar Check'},
    {value: '9', text: 'Visitors'}
  ];

  export const minuteTypes = [
    {value: '1', text: 'Minutes Before'},
    {value: '2', text: 'Minutes After'}
  ];

  export const remindTypes = [
    {value: '1', text: '5'},
    {value: '2', text: '10'},
    {value: '3', text: '30'},
    {value: '4', text: '60'},
    {value: '4', text: '120'}
  ];

  export const statusTypes = [
    {value: '1', text: 'Active'},
    {value: '2', text: 'Inactive'}
  ];


    export const usStates = [
    { value: 'OT', text: 'Others' },
    { value: 'AL', text: 'Alabama' },
    { value: 'AK', text: 'Alaska' },
    { value: 'AZ', text: 'Arizona' },
    { value: 'AR', text: 'Arkansas' },
    { value: 'CA', text: 'California' },
    { value: 'CO', text: 'Colorado' },
    { value: 'CT', text: 'Connecticut' },
    { value: 'DE', text: 'Delaware' },
    { value: 'FL', text: 'Florida' },
    { value: 'GA', text: 'Georgia' },
    { value: 'HI', text: 'Hawaii' },
    { value: 'ID', text: 'Idaho' },
    { value: 'IL', text: 'Illinois' },
    { value: 'IN', text: 'Indiana' },
    { value: 'IA', text: 'Iowa' },
    { value: 'KS', text: 'Kansas' },
    { value: 'KY', text: 'Kentucky' },
    { value: 'LA', text: 'Louisiana' },
    { value: 'ME', text: 'Maine' },
    { value: 'MD', text: 'Maryland' },
    { value: 'MA', text: 'Massachusetts' },
    { value: 'MI', text: 'Michigan' },
    { value: 'MN', text: 'Minnesota' },
    { value: 'MS', text: 'Mississippi' },
    { value: 'MO', text: 'Missouri' },
    { value: 'MT', text: 'Montana' },
    { value: 'NE', text: 'Nebraska' },
    { value: 'NV', text: 'Nevada' },
    { value: 'NH', text: 'New Hampshire' },
    { value: 'NJ', text: 'New Jersey' },
    { value: 'NM', text: 'New Mexico' },
    { value: 'NY', text: 'New York' },
    { value: 'NC', text: 'North Carolina' },
    { value: 'ND', text: 'North Dakota' },
    { value: 'OH', text: 'Ohio' },
    { value: 'OK', text: 'Oklahoma' },
    { value: 'OR', text: 'Oregon' },
    { value: 'PA', text: 'Pennsylvania' },
    { value: 'RI', text: 'Rhode Island' },
    { value: 'SC', text: 'South Carolina' },
    { value: 'SD', text: 'South Dakota' },
    { value: 'TN', text: 'Tennessee' },
    { value: 'TX', text: 'Texas' },
    { value: 'UT', text: 'Utah' },
    { value: 'VT', text: 'Vermont' },
    { value: 'VA', text: 'Virginia' },
    { value: 'WA', text: 'Washington' },
    { value: 'WV', text: 'West Virginia' },
    { value: 'WI', text: 'Wisconsin' },
    { value: 'WY', text: 'Wyoming' }
  ];
  
